import { createGlobalStyle } from 'styled-components';

import 'sanitize.css/sanitize.css';
import 'font-awesome/css/font-awesome.min.css';

import 'rsuite/styles/index.less';
import './aggrid.scss';
import './fonts.css';

const GlobalStyle = createGlobalStyle`
    html,
    body {
        margin: 0;
        min-height: 100vh;
        width: 100%;
        background-color: #FBFBFB;
    }

    body {
        font-family: 'Atlas Grotesk Regular', Verdana, sans-serif;
    }

    #app {
        height: 100%;
        width: 100%;
    }

    p,
    label {
        font-family: 'Atlas Grotesk Regular', Verdana, sans-serif;
        line-height: 1.5em;
    }
`;

export default GlobalStyle;
